module.exports = __webpack_public_path__ + "h5/static/img/spx-logo.5d21d8cd.png";